import React, { Component } from 'react'

import BreadcrumbCard from './BreadcrumbCard'
import ToolFooter from './ToolFooter'
import Utils from './Utils'
import Tools from './Tools'

import '../App.css'

class Tool extends Component {
    componentDidMount() {
        if (this.props.title) {
            Utils.injectTwitterCardTags(this.props.title)
        }
    }
    componentWillUnmount() {
        Utils.removeTwitterCardTags()
    }

    render() {
        const tool = Tools.getTool(this.props.title)

        return (
            <div id="tool">
                <BreadcrumbCard breadcrumbs={ this.props.breadcrumbs } noBorder={ this.props.noBorder }>
                    { this.props.children }
                </BreadcrumbCard>
                <ToolFooter
                    pathname={ !!tool ? tool.link : null }
                    title={ this.props.title }
                    glossary={ this.props.glossary } />
            </div>
        )
    }
}

export default Tool
